import { GenericDataType } from 'modules/domains';
import { Mapping } from 'api/MappingsAPI';
import { MergeTag, MergeTagType } from '../types';

export const convertMappingToMergeTag = ({
  fieldName,
  dataType,
}: Pick<Mapping, 'fieldName' | 'dataType'>): MergeTag => ({
  fieldName,
  type: dataType === GenericDataType.User ? MergeTagType.User : MergeTagType.Event,
});
